import { ComplexValue } from 'app/types-shared';
import { SavedReportCompanyReport } from '../types-store';

export const createDefaultSavedReport = (code: ComplexValue<number>, sequence: number): SavedReportCompanyReport => ({
  code,
  reportIdCell: undefined,
  reportIdRange: undefined,
  reportNameCell: undefined,
  reportNameRange: undefined,
  reportResultCell: undefined,
  reportResultRange: undefined,
  selectedReport: undefined,
  editable: false,
  sequence,
  disabled: undefined
});
